// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CrmAssetsManager from "../../../../../to-be-migrated/assets/CrmAssetsManager.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as OrderMapComponent from "./OrderMapComponent.bs.js";
import * as OrderDetailsMapRepoManager from "../../../../app/order-details-map/repo/OrderDetailsMapRepoManager.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

CrmAssetsManager.importCss(undefined);

function reducer(_state, action) {
  if (action.TAG === /* SetOrderDetail */0) {
    return {
            orderDetail: {
              TAG: /* Live */1,
              _0: action._0
            }
          };
  } else {
    return {
            orderDetail: {
              TAG: /* Error */2,
              _0: action._0
            }
          };
  }
}

function OrderLoaderComponent(Props) {
  var order_id = Props.order_id;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useReducer(reducer, {
        orderDetail: {
          TAG: /* Loading */0,
          _0: undefined
        }
      });
  var dispatch = match$1[1];
  var getOrderDetail = function (order_id) {
    var OrderDetailsMapRepo = OrderDetailsMapRepoManager.getRepo(undefined);
    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._2(OrderDetailsMapRepo.fetchOrderMapData, order_id, country);
                }), (function (orderDetailsInfo) {
                  return Curry._1(dispatch, {
                              TAG: /* SetOrderDetail */0,
                              _0: orderDetailsInfo
                            });
                }), (function (error) {
                  return Curry._1(dispatch, {
                              TAG: /* SetError */1,
                              _0: error
                            });
                }));
  };
  React.useEffect((function () {
          getOrderDetail(order_id);
          
        }), []);
  var liveData = match$1[0].orderDetail;
  var tmp;
  if (typeof liveData === "number") {
    tmp = null;
  } else {
    switch (liveData.TAG | 0) {
      case /* Loading */0 :
          tmp = React.createElement(LoadingViewComponent$Catalyst.make, {});
          break;
      case /* Live */1 :
          tmp = React.createElement(OrderMapComponent.make, {
                order_detail: liveData._0,
                order_id: order_id
              });
          break;
      case /* Error */2 :
          tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                error: liveData._0
              });
          break;
      
    }
  }
  return React.createElement("div", {
              className: "loader-container"
            }, tmp);
}

var make = OrderLoaderComponent;

export {
  reducer ,
  make ,
  
}
/*  Not a pure module */
